<div class="confirm-cont">
    <div class="head">
        <span>{{data?.message}}</span>
    </div>
    <div class="cont">
        <button class="btn btn-secondary" (click)="cancel()">{{data?.btncancel?data?.btncancel:'Cancel'}}</button>
        <button class="btn btn-success" (click)="Action(data?.tasktype, data)">{{data?.btnmsg}}</button>
    </div>
</div>